var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreShopify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#95BF46;}\n\t.st1{fill:#5E8E3E;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopify-2",
    transform: "translate(8601.066 -142.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M-8525.78,169.42c-0.06-0.33-0.33-0.59-0.67-0.62c-0.28-0.02-6.16-0.46-6.16-0.46 s-4.08-4.06-4.53-4.5c-0.49-0.33-1.11-0.41-1.66-0.21c-0.05,0.01-0.89,0.27-2.29,0.71c-1.36-3.93-3.77-7.54-8.01-7.54 c-0.12,0-0.24,0-0.36,0.01c-1.2-1.59-2.7-2.29-3.99-2.29c-9.87,0-14.58,12.34-16.06,18.61c-3.83,1.19-6.56,2.03-6.91,2.14 c-2.14,0.67-2.21,0.74-2.49,2.76c-0.21,1.53-5.81,44.84-5.81,44.84l43.64,8.18l23.65-5.12 C-8517.42,225.92-8525.72,169.8-8525.78,169.42L-8525.78,169.42z M-8543.5,165.07l-3.69,1.14c0-0.26,0-0.52,0-0.8 c0.04-2.02-0.26-4.04-0.88-5.96C-8545.89,159.73-8544.44,162.22-8543.5,165.07z M-8550.78,159.94c0.74,2.14,1.08,4.39,1,6.65 c0,0.15,0,0.29,0,0.43l-7.63,2.36C-8555.94,163.71-8553.19,160.98-8550.78,159.94z M-8553.71,157.17c0.46,0.01,0.9,0.16,1.27,0.43 c-3.16,1.49-6.55,5.24-7.98,12.72l-6.03,1.87C-8564.78,166.47-8560.8,157.17-8553.71,157.17L-8553.71,157.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st1",
    d: "M-8526.44,168.8c-0.28-0.02-6.16-0.46-6.16-0.46s-4.08-4.06-4.53-4.5 c-0.17-0.16-0.4-0.26-0.63-0.29l-3.3,67.49l23.64-5.11c0,0-8.3-56.12-8.35-56.51C-8525.83,169.08-8526.11,168.83-8526.44,168.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "st2",
    d: "M-8549.1,181.87l-2.92,8.67c-1.77-0.87-3.71-1.33-5.68-1.36c-4.59,0-4.82,2.88-4.82,3.61 c0,3.96,10.33,5.48,10.33,14.76c0,7.3-4.63,12-10.87,12c-7.49,0-11.32-4.66-11.32-4.66l2-6.63c0,0,3.94,3.38,7.26,3.38 c1.62,0.07,2.98-1.19,3.05-2.8c0-0.05,0-0.1,0-0.16c0-5.17-8.47-5.4-8.47-13.89c0-7.15,5.13-14.06,15.48-14.06 C-8551.07,180.72-8549.1,181.87-8549.1,181.87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreShopify);
export default __webpack_public_path__ + "static/media/store-shopify.ed44f406340e5231bb07bb8af58e9ba4.svg";
export { ForwardRef as ReactComponent };